import { AccessTime } from '@mui/icons-material'
import { Avatar, Box, Typography } from '@mui/material'
import SegmentBaggageWrapper from './segmentBaggage'

interface SegmentBlockProps {
    segmentKey: string
    airlineLogo: string
    airlineName: string
    flightNumber: string
    cabinType: string
    departureTime: string
    departureCode: string
    departureAirport: string
    duration: string
    arrivalTime: string
    arrivalAirport: string
    arrivalCode: string
    isConfirmationPage?: boolean
    operatedBy: string
    baggage?: { cab?: string; cib?: string; freeText?: string; additionalBaggage?: string; fareType?: string }
}

const SegmentBlock = ({
    segmentKey,
    airlineLogo,
    airlineName,
    flightNumber,
    cabinType,
    departureTime,
    departureCode,
    departureAirport,
    duration,
    arrivalTime,
    arrivalAirport,
    arrivalCode,
    isConfirmationPage = false,
    operatedBy,
    baggage
}: SegmentBlockProps) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'top', gap: 1, px: 2 }}>
            <Box sx={{ display: 'flex', gap: 3, alignItems: 'top' }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        minWidth: '90px',
                        width: '90px'
                    }}
                >
                    <Avatar
                        src={airlineLogo}
                        alt={airlineName}
                        variant="square"
                        sx={{
                            width: 40,
                            height: 40,
                            mb: 1,
                            '& img': { objectFit: 'contain' }
                        }}
                    />
                    <Typography sx={{ fontWeight: 600, fontSize: 14, textAlign: 'center' }}>{airlineName}</Typography>
                    <Typography sx={{ fontSize: 12, color: 'textColors.subheading', textAlign: 'center' }}>
                        {flightNumber}
                    </Typography>
                    <Typography
                        sx={{ fontSize: 12, color: 'textColors.disabled', textAlign: 'center', fontWeight: 500 }}
                    >
                        {cabinType}
                    </Typography>

                    {operatedBy && (
                        <Typography
                            sx={{ fontSize: 12, color: 'textColors.disabled', textAlign: 'center', fontWeight: 500 }}
                        >
                            {operatedBy}
                        </Typography>
                    )}
                </Box>

                {/* Flight Timeline */}
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', position: 'relative' }}>
                    {/* Departure */}
                    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                        <Typography sx={{ fontWeight: 'bold', fontSize: 18, color: 'textColors.primary' }}>
                            {departureTime}
                        </Typography>
                        <Typography sx={{ fontSize: 16, color: 'primary.dark' }}>{departureCode}</Typography>
                        <Typography sx={{ color: 'textColors.subtitle', fontSize: 14, fontWeight: 600 }}>
                            {departureAirport}
                        </Typography>
                    </Box>

                    {/* Flight Path */}
                    <Box sx={{ display: 'flex', alignItems: 'center', my: 1, position: 'relative' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mr: 2 }}>
                            <Box
                                sx={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    bgcolor: 'primary.main'
                                }}
                            />
                            <Box
                                sx={{
                                    width: 2,
                                    height: 32,
                                    bgcolor: 'primary.light'
                                }}
                            />
                            <Box
                                sx={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    bgcolor: 'primary.main'
                                }}
                            />
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                mx: 1,
                                fontSize: 14,
                                color: 'textColors.secondary',
                                fontWeight: 500
                            }}
                        >
                            <AccessTime sx={{ mr: 0.5, fontSize: '14px' }} />
                            {duration}
                            {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 2 }}>
                                <Avatar sx={{ width: 20, height: 20, bgcolor: 'neutral.100' }}>
                                    <Wifi sx={{ fontSize: '12px', color: 'success.main' }} />
                                </Avatar>
                                <Avatar sx={{ width: 20, height: 20, bgcolor: 'neutral.100' }}>
                                    <Power sx={{ fontSize: '12px', color: 'success.main' }} />
                                </Avatar>
                                <Avatar sx={{ width: 20, height: 20, bgcolor: 'neutral.100' }}>
                                    <Movie sx={{ fontSize: '12px', color: 'error.main' }} />
                                </Avatar>
                                <Avatar sx={{ width: 20, height: 20, bgcolor: 'neutral.100' }}>
                                    <ChildCare sx={{ fontSize: '12px', color: 'error.main' }} />
                                </Avatar>
                                <Avatar sx={{ width: 20, height: 20, bgcolor: 'neutral.100' }}>
                                    <Restaurant sx={{ fontSize: '12px', color: 'error.main' }} />
                                </Avatar>
                            </Box> */}
                        </Box>
                    </Box>

                    {/* Arrival */}
                    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                        <Typography sx={{ fontWeight: 'bold', fontSize: 18, color: 'textColors.primary' }}>
                            {arrivalTime}
                        </Typography>
                        <Typography sx={{ fontSize: 16, color: 'primary.dark' }}>{arrivalCode}</Typography>
                        <Typography sx={{ color: 'textColors.subtitle', fontSize: 14, fontWeight: 600 }}>
                            {arrivalAirport}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* Baggage - hide on confirmation page */}
            {!isConfirmationPage && <SegmentBaggageWrapper segmentKey={segmentKey} baggage={baggage} />}
        </Box>
    )
}

export default SegmentBlock
